<template>
  <div>
    <help v-if="showHelp" ></help>
    <new-file v-else-if="showNewFile"></new-file>
    <new-dir v-else-if="showNewDir"></new-dir>
    <new-inbox v-else-if="showNewInbox"></new-inbox>
    <rename v-else-if="showRename"></rename>
    <delete v-else-if="showDelete"></delete>
    <delete-coupon v-else-if="showDeleteCoupon"></delete-coupon>
    <delete-private-space v-else-if="showDeletePrivateSpace"></delete-private-space>
    <info v-else-if="showInfo"></info>
    <logout v-else-if="showLogout"></logout>
    <create-account v-else-if="showCreateAccount"></create-account>
    <free-trial v-else-if="showFreeTrial"></free-trial>
    <open-private-space v-else-if="showOpenPrivateSpace"></open-private-space>
    <create-private-space v-else-if="showCreatePrivateSpace"></create-private-space>
    <check-password v-else-if="showCheckPassword"></check-password>
    <modify-private-space v-else-if="showModifyPrivateSpace"></modify-private-space>
    <mfa v-else-if="showMfa"></mfa>
    <move v-else-if="showMove"></move>
    <download-from-link v-else-if="showDownloadFromLink"></download-from-link>
    <copy v-else-if="showCopy"></copy>
    <replace v-else-if="showReplace"></replace>
    <share v-else-if="show === 'share'"></share>
    <empty-trash v-else-if="show === 'empty-trash'"></empty-trash>
    <create-unit v-else-if="show === 'create-unit'"></create-unit>
    <manage-access v-else-if="show === 'manage-access'"></manage-access>
    <cancel-subscription v-else-if="show === 'cancel-subscription'"></cancel-subscription>
    <change-plan v-else-if="show === 'change-plan'"></change-plan>
    <version-history v-else-if="show === 'version-history'"></version-history>
    <delete-shared-drive v-else-if="show === 'delete-shared-drive'"></delete-shared-drive>
    <archive-shared-drive v-else-if="show === 'archive-shared-drive'"></archive-shared-drive>
    <show-info-log v-else-if="show === 'show-info-log'" v-bind:data="showData"></show-info-log>
    <join-link v-else-if="showJoinLink"></join-link>
    <terms-conditions v-else-if="showTermsConditions"></terms-conditions>
    <modify-backup v-else-if="show === 'modify-backup'"></modify-backup>
    <item-options :style="itemOptionsStyle"></item-options>
    <div v-show="showOverlay" @click="resetPrompts" class="overlay"></div>
  </div>
</template>

<script>
import Help from './Help.vue';
import Info from './Info.vue';
import Mfa from './Mfa.vue';
import Delete from './Delete.vue';
import DeleteSharedDrive from './DeleteSharedDrive.vue';
import ArchiveSharedDrive from './ArchiveSharedDrive.vue';
import DeleteCoupon from './DeleteCoupon.vue';
import DeletePrivateSpace from './DeletePrivateSpace.vue';
import Rename from './Rename.vue';
import Move from './Move.vue';
import DownloadFromLink from './DownloadFromLink.vue';
import Copy from './Copy.vue';
import NewFile from './NewFile.vue';
import NewDir from './NewDir.vue';
import NewInbox from './NewInbox.vue';
import Replace from './Replace.vue';
import Share from './Share.vue';
import Logout from './Logout.vue';
import CreateAccount from './CreateAccount.vue';
import JoinLink from './JoinLink.vue';
import TermsConditions from './TermsConditions.vue';
import { mapState, mapMutations } from 'vuex';
import buttons from '@/utils/buttons';
import FreeTrial from './FreeTrial.vue';
import OpenPrivateSpace from './OpenPrivateSpace.vue';
import CreatePrivateSpace from './CreatePrivateSpace.vue';
import CheckPassword from './CheckPassword.vue';
import ModifyPrivateSpace from './ModifyPrivateSpace.vue';
import EmptyTrash from './EmptyTrash.vue';
import CreateUnit from './CreateUnit.vue';
import ManageAccess from './ManageAccess.vue';
import CancelSubscription from './CancelSubscription.vue';
import ChangePlan from './ChangePlan.vue';
import VersionHistory from './VersionHistory.vue';
import ItemOptions from './ItemOptions.vue';
import ShowInfoLog from './ShowInfoLog.vue';
import ModifyBackup from './ModifyBackup.vue';

export default {
  name: 'prompts',
  components: {
    Info,
    Mfa,
    Delete,
    DeleteCoupon,
    Rename,
    Move,
    DownloadFromLink,
    Copy,
    Share,
    JoinLink,
    NewFile,
    NewDir,
    NewInbox,
    Help,
    Replace,
    TermsConditions,
    Logout,
    CreateAccount,
    FreeTrial,
    OpenPrivateSpace,
    CreatePrivateSpace,
    ModifyPrivateSpace,
    DeletePrivateSpace,
    CheckPassword,
    EmptyTrash,
    CreateUnit,
    ManageAccess,
    CancelSubscription,
    ChangePlan,
    VersionHistory,
    ItemOptions,
    DeleteSharedDrive,
    ArchiveSharedDrive,
    ShowInfoLog,
    ModifyBackup,
},
  data: function () {
    return {
      pluginData: {
        buttons,
        'store': this.$store,
        'router': this.$router
      }
    };
  },
  computed: {
    ...mapState(['show', 'plugins', 'showData']),
    showInfo: function () { return this.show === 'info'; },
    showMfa: function () { return this.show === 'mfa'; },
    showHelp: function () { return this.show === 'help'; },
    showDelete: function () { return this.show === 'delete'; },
    showDeleteCoupon: function () { return this.show === 'delete-coupon'; },
    showDeletePrivateSpace: function () { return this.show === 'delete-private-space'; },
    showRename: function () { return this.show === 'rename'; },
    showMove: function () { return this.show === 'move'; },
    showDownloadFromLink: function () { return this.show === 'download-from-link'; },
    showCopy: function () { return this.show === 'copy'; },
    showNewFile: function () { return this.show === 'newFile'; },
    showNewDir: function () { return this.show === 'newDir'; },
    showNewInbox: function () { return this.show === 'newInbox'; },
    showReplace: function () { return this.show === 'replace'; },
    showJoinLink: function () { return this.show === 'join-link';},
    showTermsConditions: function () { return this.show === 'termsConditions';},
    showLogout: function () { return this.show === 'logout'; },
    showCreateAccount: function () { return this.show === 'create-account'; },
    showFreeTrial: function () { return this.show === 'free-trial'; },
    showOpenPrivateSpace: function () { return this.show === 'open-private-space'; },
    showCreatePrivateSpace: function () { return this.show === 'create-private-space'; },
    showCheckPassword: function () { return this.show === CheckPassword.name; },
    showModifyPrivateSpace: function () { return this.show === 'modify-private-space'; },
    showOverlay: function () {
      return (this.show !== null && this.show !== 'search' && this.show !== 'more');
    },
    itemOptionsStyle () {
      if (this.show === 'item-options') {
        this.setIsPrompt(true);
        return {right: '0px'};
      } else if (this.show !== 'copy' && this.show !== 'move' && this.show !== 'rename' && this.show !== 'share' && this.show !== 'delete' && this.show !== 'manage-access' && this.show !== 'delete-shared-drive' && this.show !== 'archive-shared-drive') {
        this.setIsPrompt(false);
        return {right: 'calc(-1*var(--width))'};
      } else {
        return {right: 'calc(-1*var(--width))'};
      }
    },
  },
  methods: {
    ...mapMutations(['setIsPrompt']),
    resetPrompts () {
      this.$store.commit('closeHovers');
    }
  }
};
</script>
